<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-file-text-o"></span>Tasks list</div>
  </div>
  <div class="content">

    <p-table #tt [columns]="cols" [value]="tasks" selectionMode="single" (onRowSelect)="onRowSelect($event)">
      <ng-template pTemplate="caption">
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" pInputText size="50" placeholder="Global Filter"
               (input)="tt.filterGlobal($event.target['value'] , 'contains')" style="width:auto">
        <!--        todo(dcorbett event.target.value has changed)-->
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{col.header}}
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field"
              style="background: aliceblue; display: contents;">
            <!--<input *ngSwitchCase="'Description'" pInputText type="text" (input)="tt.filter($event.target.value, col.field, col.filterMatchMode)">-->
            <!--<p-multiSelect *ngSwitchCase="'Assignee'" [options]="employees" defaultLabel="All employees" (onChange)="tt.filter($event.value, col.field, 'in')" [showToggleAll]="true" [(ngModel)]="selectedEmployees" [filter]="false"></p-multiSelect>-->
            <p-multiSelect *ngSwitchCase="'Assignee'" [options]="employees"
                           (onChange)="refilterList($event, tt)"
                           [showToggleAll]="false" [filter]="false"></p-multiSelect>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns" pEditableColumn style="overflow:visible;padding:2px 8px !important">
            <div *ngIf="col.type=='dropdown'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown [options]="employees" [(ngModel)]="rowData.Assignee"
                              [style]="{'width':'100%'}"></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  {{rowData[col.field]}}
                </ng-template>
              </p-cellEditor>
            </div>
            <div *ngIf="col.type=='readonlyDate'">
              {{rowData[col.field]  | date: "dd MMM yyyy"}}
            </div>
            <div *ngIf="col.type=='readonly'">
              {{rowData[col.field]}}
            </div>
            <div *ngIf="col.type=='action'" style="display:grid;">
              <button pButton type="button" class="p-button-raised icon" label="View Claim"
                      (click)="displayClaim(rowData[col.field])" iconPos="right"></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>
</div>


<p-sidebar #NavSideBar [(visible)]="showClaim" [fullScreen]="true" [baseZIndex]="10000" [showCloseIcon]="true"
           [style]="{'overflow': 'scroll'}" (onHide)="refreshList(); NavSideBar.destroyModal()">
  <div>
    <app-single-claim [claimID]="claimID"></app-single-claim>
    <!--<app-view-claims [claim]="claimObject"></app-view-claims>-->
  </div>
</p-sidebar>
